import { Injectable } from '@angular/core';
import { AngularFireAuth } from 'angularfire2/auth';
import * as firebase from 'firebase/app';

@Injectable()
export class AuthService {

  isLoggedIn: Boolean;
  displayName: String;
  email: String;

  constructor(public afAuth: AngularFireAuth) {
    afAuth.auth.onAuthStateChanged(
      user => {
        // console.log('Auth state changed: ' + JSON.stringify(user));
        if (user) {
          this.isLoggedIn = true;
          this.displayName = user.displayName;
          this.email = user.email;
        } else {
          this.isLoggedIn = false;
          this.displayName = '';
          this.email = '';
        }
      }
    );
  }

  loginGoogle() {
    return this.afAuth.auth.signInWithPopup(new firebase.auth.GoogleAuthProvider());
  }

  loginEmail(email, password) {
    return this.afAuth.auth.signInWithEmailAndPassword(email, password);
  }
  
  register(email, password) {
    return this.afAuth.auth.createUserWithEmailAndPassword(email, password);
  }

  logout() {
    return this.afAuth.auth.signOut();
  }
}


// WEBPACK FOOTER //
// /var/www/html/mediate/src/app/providers/auth.service.ts